module.exports = __webpack_public_path__ + "static/media/p3.2a7c4032.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p3.webp
// module id = 268
// module chunks = 0